import Itly from 'itly';
import { useWindowSize, DeviceSize } from 'hooks/useWindowSize';
import React, { useEffect, useRef, useCallback } from 'react';
import { useChatContext } from '../ChatContext';
import { ExpandButton } from './styles';

export const ChatExpand = (): JSX.Element => {
  const { isExpanded, setIsExpanded } = useChatContext();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const { deviceSize } = useWindowSize();
  const isMobile = deviceSize === DeviceSize.SMALL;

  useEffect(() => {
    const btn = buttonRef.current;
    if (!btn) {
      return;
    }

    const prevent = (e: WheelEvent) => e.preventDefault();
    btn.addEventListener('wheel', prevent, { passive: false });
    return () => btn.removeEventListener('wheel', prevent);
  }, []);

  const handleClick = useCallback(() => {
    setIsExpanded(!isExpanded);
    Itly.productAssistantExpandClicked({ current_url: window.location.href });
  }, [isExpanded, setIsExpanded]);

  if (isMobile) {
    return null;
  }

  return (
    <ExpandButton ref={buttonRef} onClick={handleClick} aria-label="Expand chat">
      {isExpanded && (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="100%" height="100%" fill="transparent" />
          <path
            d="M11 1L11 7M11 7L17.0004 7M11 7L17.0003 1.09991M1.00018 11L7.00018 11M7.00018 11L7.00018 17M7.00018 11L1.00018 17"
            stroke="#333333"
          />
        </svg>
      )}
      {!isExpanded && (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="100%" height="100%" fill="transparent" />
          <path
            d="M8.99888 1.00112L15.0002 1.00022M15.0002 1.00022L14.9993 7.00112M15.0002 1.00022L8.99888 7.00112M0.999065 9.00112L1 15M1 15L6.99906 15.0011M1 15L6.99906 9.00112"
            stroke="#333333"
          />
        </svg>
      )}
    </ExpandButton>
  );
};
